import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import CheckBox from 'Common/Components/Checkbox';
import { downloadVulns } from 'store/Manage/actions';
import {
  Wrapper,
  ExportButton,
  WrapperField,
  Label
} from './styled';
import useClickOutside from 'Hooks/useClickOutside';

const Dropdown = ({ showDropdown, setShowDropdown, wrapperRef }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [exportAllData, setExportAllData] = useState(false);

  useClickOutside(wrapperRef, () => setShowDropdown(!showDropdown));

  const download = (e) => {
    e.stopPropagation();
    dispatch(downloadVulns(exportAllData));
    setShowDropdown(!showDropdown);
  };

  return (
    <Wrapper >
      <ExportButton onClick={ (e) => download(e) }>{ intl.formatMessage({ id: 'vulns.exportCSV.button' }) }</ExportButton>
      <WrapperField>
        <CheckBox checked={ exportAllData } onChange={ () => setExportAllData(!exportAllData) } state={ exportAllData } />
        <Label>{ intl.formatMessage({ id: 'vulns.exportCSV.checkbox.label' }) }</Label>
      </WrapperField>
    </Wrapper>
  );
};

export default Dropdown;
